import request from '@/utils/httpRequest'

// article移动
export function articleMove(data) {
  return request({
    url: `/articleInfo/moveItem`,
    method: 'post',
    data
  })
}

// 发布article
export function articleOperate(data) {
  return request({
    url: `/articleInfo/publish`,
    method: 'post',
    data
  })
}
// 删除article
export function articleDelete(id) {
  return request({
    url: `/articleInfo/delete/${id}`,
    method: 'post',
    data: {}
  })
}

// 获取文章分页列表
export function getArticleList(params) {
  return request({
    url: `/articleInfo/listPage`,
    method: 'get',
    params
  })
}
// 提交审批
export function approveOpreate(data) {
  return request({
    url: '/approve/commitApprove',
    method: 'post',
    data
  })
}
